import type ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { Observable, map } from "rxjs";
import { create } from "superstruct";
import { inject, singleton } from "tsyringe";

import { nudgesAuthApiClientToken } from "../../tokens";
import {
    NudgesSettingsResponseSchema,
    NudgesSettingsResponseType,
} from "./response/NudgesSettingsResponseSchema";

@singleton()
class NudgesSettingsApiService {
    constructor(
        @inject(nudgesAuthApiClientToken)
        private readonly apiClient: ApiClientInterface
    ) {}

    public isAllowed(): Observable<NudgesSettingsResponseType> {
        return this.apiClient
            .get({
                url: "/isAllowed",
                responseType: "json",
            })
            .pipe(
                map((response) =>
                    create(response.body, NudgesSettingsResponseSchema)
                )
            );
    }
}

export default NudgesSettingsApiService;
